import React from 'react';
import BarChartDrillDownReports from "./BarChartDrillDownReports";
import { BsLightbulb } from "react-icons/bs";
import BarChartSoftdata from './BartChartSoftdata';

class BarChartReports extends React.Component {

    constructor(props) {
        super(props);
        this.state = {      
            quadroId: props.quadroId,      
            textoNota: props.textoNota,
            drillDown: props.drillDown,
            barData: props.barData,
            nomeY: props.nomeY,
            precision: props.precision,
            data: props.data,
            selectedData: null,     
            chartLabel: props.chartLabel,       
        }
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.initializeState = this.initializeState.bind(this);
        this.handleBarClick = this.handleBarClick.bind(this);
        this.handleClickMainChart = this.handleClickMainChart.bind(this);
    }

    initializeState(props) {
        // Agrupámos tudo num só setState para ser instantâneo
        this.setState({
            quadroId: props.quadroId,
            textoNota: props.textoNota,
            drillDown: props.drillDown,
            barData: props.barData,
            nomeY: props.nomeY,
            precision: props.precision,
            data: props.data,
            selectedData: null,
            chartLabel: props.chartLabel
        });
    }

    componentDidUpdate(prevProps) {
        // Agora atualiza quer o ID mude, quer os dados do gráfico mudem!
        if (this.props.quadroId !== prevProps.quadroId || this.props.barData !== prevProps.barData) {
            this.initializeState(this.props);
        }
    }

    componentDidMount() {
        this.initializeState(this.props);
    }    

    handleBarClick = (data, index) => {
        if (this.state.drillDown){
            this.setState({selectedData: data});
        }
    };

    handleClickMainChart = () => {
        this.setState({selectedData: null});
    }

    render() {
        return (
            <div>
                {!this.state.selectedData &&
                    <div>
                        <h6 style={{ textAlign: "right" }}>{this.state.chartLabel}</h6>
                        
                        {/* A Lâmpada só aparece se o gráfico tiver Drill Down */}
                        {this.state.drillDown && 
                            <>
                                <BsLightbulb title="Este é um gráfico Drill-Down.
                                Clique em cada um dos items para apresentar um 2º gráfico
                                com informação adicional do item seleccionado"/>
                                <span style={{fontSize: "12px"}}>&nbsp;Nota</span>
                            </>
                        }
                    </div>
                }

                {!this.state.selectedData &&
                    <BarChartSoftdata 
                        barData={this.state.barData}
                        nomeY={this.state.nomeY}
                        handleBarClick={this.handleBarClick}
                    />                    
                }

                {this.state.drillDown && this.state.selectedData && 
                    <div>                                            
                        <BarChartDrillDownReports 
                            quadroId={this.state.quadroId} 
                            line={this.state.selectedData.activeLabel} 
                            data={this.state.data} 
                            precision={this.state.precision}
                            onClickEventHandler={this.handleClickMainChart}
                        />
                    </div>
                }
            </div>            
        );
    }
}

export default BarChartReports;